<div class="drawer-shell">
  <header class="drawer-header">
    <div>
      <div class="drawer-brand">MAQI</div>
      <p class="drawer-subtitle">MPC Advanced Queries Interface</p>
    </div>
    <button mat-icon-button type="button" class="drawer-close" aria-label="Close navigation" (click)="navAction.emit()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <nav class="drawer-section" aria-label="Main navigation">
    <div class="drawer-section-label">Navigation</div>
    <a
      *ngFor="let link of links"
      class="drawer-link"
      [routerLink]="link.path"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: link.exact === true }"
      (click)="navAction.emit()"
      >{{ link.label }}</a
    >
  </nav>

  @if (isAuthenticated) {
  <section class="drawer-section drawer-account-section" aria-label="Account">
    <div class="drawer-section-label">Account</div>
    @if (userEmail) {
    <p class="drawer-signed-in">Signed in as <strong>{{ userEmail }}</strong></p>
    }
    <a class="drawer-link drawer-link-secondary" routerLink="/account" routerLinkActive="active" (click)="navAction.emit()">
      Account
    </a>
    <a class="drawer-link drawer-link-secondary" routerLink="/history" routerLinkActive="active" (click)="navAction.emit()">
      History
    </a>
    <button class="drawer-link drawer-logout" type="button" (click)="logout.emit(); navAction.emit()">Logout</button>
  </section>
  }
</div>
